/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import React from 'react';
import { NodeType } from '../../../../backendModels/report.model';
import { SituationsAndSymptomsKeys } from '../../../../models/situationsAndSymptoms';
import { CardId } from '../../../../models/diviCard';
import SituationAndSymptoms from '../SituationAndSymptoms/SituationAndSymptoms';

interface FirstAiderProps {
  readonly nodeType: NodeType;
}

const firstAiderKeys = [
  SituationsAndSymptomsKeys.ehSuffizient,
  SituationsAndSymptomsKeys.ehInsuffizient,
  SituationsAndSymptomsKeys.keineEH,
];

export default function FirstAider({ nodeType }: FirstAiderProps) {
  return (
    <SituationAndSymptoms nodeType={nodeType} situationAndSymptomsKeys={firstAiderKeys} cardId={CardId.FirstAider} />
  );
}
